import { h, Component, Fragment } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

function formatDate(value) {
    if (!value) {
        return '';
    }
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) {
        return '';
    }
    const pad = n => String(n).padStart(2, '0');
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
}

function isExpired(value) {
    if (!value) {
        return false;
    }
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return false;
    const end = new Date(d);
    end.setHours(23, 59, 59, 999);
    return end.getTime() < Date.now();
}

@observer
class WeaponCardList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmDelete: '',
        };
    }

    componentDidMount() {
        const { weaponCardStore } = this.props.stores;
        weaponCardStore.loadCards();
    }

    reload = () => {
        const { weaponCardStore } = this.props.stores;
        weaponCardStore.loadCards();
    }

    add = () => {
        const { appState } = this.props.stores;
        appState.openDrawer('addWeaponCard', {
            height: appState.drawerHeightMediumLarge,
            isNew: true,
            callback: this.reload,
        }, 1);
    }

    edit = (card) => {
        const { appState } = this.props.stores;
        appState.openDrawer('editWeaponCard', {
            height: appState.drawerHeightMediumLarge,
            isNew: false,
            card,
            callback: this.reload,
        }, 1);
    }

    show = (card) => {
        const { appState } = this.props.stores;
        appState.openDrawer('showWeaponCard', {
            height: appState.drawerHeightMediumLarge,
            card,
        }, 1);
    }

    askDelete = (uuidv4) => {
        this.setState({ confirmDelete: uuidv4 });
    }

    cancelDelete = () => {
        this.setState({ confirmDelete: '' });
    }

    confirmDelete = async (uuidv4) => {
        const { weaponCardStore } = this.props.stores;
        await weaponCardStore.removeCard(uuidv4);
        this.setState({ confirmDelete: '' });
    }

    render() {
        const { weaponCardStore } = this.props.stores;
        const { weaponCards = [], isLoading, lastError } = weaponCardStore;
        const { confirmDelete } = this.state;

        return (
            <div class='w-100 mb-4'>
                <div class='d-flex justify-content-between align-items-center mb-2'>
                    <h6 class='mb-0'>
                        <i class='fa-duotone fa-id-card me-2' />
                        <Text id='weaponCard.title'>My weapon cards</Text>
                    </h6>
                    <button type='button' class='btn btn-sm btn-primary rounded-pill btn-add' onClick={this.add}>
                        <i class='fa-solid fa-plus me-1' />
                        <Text id='weaponCard.add'>Add weapon card</Text>
                    </button>
                </div>
                <small class='text-body-secondary d-block mb-2'>
                    <i class='fa-duotone fa-lock me-1' />
                    <Text id='weaponCard.privacy'>Only you can see your weapon cards. The card image is never uploaded; only the text in the QR code is stored.</Text>
                </small>
                {lastError && <div class='alert alert-danger py-2'>{lastError}</div>}
                {isLoading && weaponCards.length === 0 && <span class='spinner-border spinner-border-sm' />}
                {!isLoading && weaponCards.length === 0 && (
                    <div class='text-body-secondary py-2'>
                        <Text id='weaponCard.empty'>No weapon cards yet. Add the QR card you downloaded from Altinn.</Text>
                    </div>
                )}
                {weaponCards.length > 0 && (
                    <ul class='list-group'>
                        {weaponCards.map(card => (
                            <li key={card.uuidv4} class='list-group-item d-flex flex-wrap justify-content-between align-items-center gap-2'>
                                <div>
                                    <strong>{`${card.brand || ''} ${card.model || ''}`.trim() || <Text id='weaponCard.unnamed'>Weapon</Text>}</strong>
                                    {card.caliber && <span class='badge bg-secondary ms-2'>{card.caliber}</span>}
                                    {card.validUntil && (
                                        <small class={`ms-2 ${isExpired(card.validUntil) ? 'text-danger' : 'text-body-secondary'}`}>
                                            <Text id='weaponCard.valid-until'>Valid until</Text> {formatDate(card.validUntil)}
                                        </small>
                                    )}
                                    {card.note && <small class='d-block text-body-secondary'>{card.note}</small>}
                                </div>
                                <div class='d-flex gap-1'>
                                    <button type='button' class='btn btn-sm btn-primary rounded-pill btn-show' onClick={() => this.show(card)}>
                                        <i class='fa-solid fa-qrcode me-1' />
                                        <Text id='weaponCard.show'>Show</Text>
                                    </button>
                                    <button type='button' class='btn btn-sm btn-outline-secondary rounded-pill btn-edit' onClick={() => this.edit(card)}>
                                        <Text id='weaponCard.edit'>Edit</Text>
                                    </button>
                                    {confirmDelete === card.uuidv4 ? (
                                        <Fragment>
                                            <button type='button' class='btn btn-sm btn-danger rounded-pill btn-delete-confirm' onClick={() => this.confirmDelete(card.uuidv4)}>
                                                <Text id='weaponCard.delete-confirm'>Confirm delete</Text>
                                            </button>
                                            <button type='button' class='btn btn-sm btn-outline-secondary rounded-pill' onClick={this.cancelDelete}>
                                                <Text id='weaponCard.cancel'>Cancel</Text>
                                            </button>
                                        </Fragment>
                                    ) : (
                                        <button type='button' class='btn btn-sm btn-outline-danger rounded-pill btn-delete' onClick={() => this.askDelete(card.uuidv4)}>
                                            <Text id='weaponCard.delete'>Delete</Text>
                                        </button>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        );
    }
}

export default WeaponCardList;
